import { render, staticRenderFns } from "./LetterboxUpload.vue?vue&type=template&id=09578e60&scoped=true&"
import script from "./LetterboxUpload.vue?vue&type=script&lang=ts&"
export * from "./LetterboxUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09578e60",
  null
  
)

export default component.exports